import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
export const TableContainer = forwardRef(function TableContainer({ className, ...rest }, ref) {
    return _jsx("div", { ref: ref, className: cn('sec-table-container', className), ...rest });
});
export const Table = forwardRef(function Table({ className, ...rest }, ref) {
    return _jsx("table", { ref: ref, className: cn('sec-table', className), ...rest });
});
export const TableHead = forwardRef(function TableHead({ ...rest }, ref) {
    return _jsx("thead", { ref: ref, ...rest });
});
export const TableBody = forwardRef(function TableBody({ ...rest }, ref) {
    return _jsx("tbody", { ref: ref, ...rest });
});
export const TableRow = forwardRef(function TableRow({ ...rest }, ref) {
    return _jsx("tr", { ref: ref, ...rest });
});
export const TableCell = forwardRef(function TableCell({ as = 'td', align, className, style, ...rest }, ref) {
    const Tag = as;
    return (_jsx(Tag, { ref: ref, scope: as === 'th' ? 'col' : undefined, className: cn(className), style: align ? { textAlign: align, ...style } : style, ...rest }));
});
